import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CourseDetails } from './course.model';

export const selectCourseDetailsState = createFeatureSelector<CourseDetails>('courseDetails');

export const selectCourseDetails = createSelector(selectCourseDetailsState, (entities) => entities);
